import { SignatureType, UploadPath } from 'queries';

export const signatureTypeSelectOptions = [
  { label: 'No signature', value: SignatureType.NoSignature },
  { label: 'E-signature', value: SignatureType.ESignature },
  { label: 'Physical signature no-mail', value: SignatureType.PhysicalSignatureNoMail },
  {
    label: 'Physical signature mail-required',
    value: SignatureType.PhysicalSignatureMailRequired,
  },
  {
    label: 'Physical signature and notary no-mail',
    value: SignatureType.PhysicalSignatureAndNotaryNoMail,
  },
  {
    label: 'Physical signature and notary mail required',
    value: SignatureType.PhysicalSignatureAndNotaryMailRequired,
  },
  {
    label: 'Signature (Wet or Electronic)',
    value: SignatureType.SignatureWetOrElectronic,
  },
];

export const uploadPathSelectOptions = [
  { label: 'Uploads', value: UploadPath.Uploads },
  { label: 'Search Correspondence', value: UploadPath.SearchResults },
  { label: 'Generated Documents', value: UploadPath.GeneratedDocuments },
  {
    label: 'Documents for Signature',
    value: UploadPath.DocumentsForSignature,
  },
];
